<template>
  <div>
    <b-alert variant="success"
             dismissible
             fade
             :show="showSuccessUpdateMessage">
      Zip codes were saved.
    </b-alert>
    <b-row align-v="center">
      <b-col cols="10">
        <span> {{ countryName }} ({{ zipcodesCount }})</span>
        <b-form-textarea v-model="zipCodesString"
                         :disabled="!updateAllowed"
                         :rows="3"
                         :max-rows="3"
                         placeholder="Comma separated zip codes">
         </b-form-textarea>
      </b-col>
      <b-col cols="1">
        <button-with-spinner
          :disabled="!updateAllowed"
          :click="submitDistrictCodeForm"
          :showSpinner="loading"
          :variant="supposedToBeDeleted ? 'danger' : 'success'">
          {{ submitButtonText }}
        </button-with-spinner>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DistrictCodesProvider from '@/services/DistrictCodesProvider'
import ButtonWithSpinner from '@/components/ButtonWithSpinner'

export default {
  name: 'DistrictCodeItem',
  components: {
    ButtonWithSpinner
  },
  props: {
    id: Number,
    zipCodesList: Array,
    countryCode: String,
    countryName: String,
    assignmentTermId: Number,
    entireCountry: Boolean,
    updateAllowed: Boolean,
    afterDestroy: Function
  },
  data () {
    return {
      editableZipCodesList: this.zipCodesList,
      loading: false,
      showSuccessUpdateMessage: false
    }
  },
  computed: {
    zipCodesString: {
      get: function () {
        return this.editableZipCodesList.join(', ')
      },
      set: function (zipCodesString) {
        this.editableZipCodesList = zipCodesString.split(', ')
      }
    },
    supposedToBeDeleted () {
      return this.zipCodesString === ''
    },
    submitButtonText () {
      if (this.supposedToBeDeleted) {
        return 'Delete'
      } else {
        return 'SAVE'
      }
    },
    zipcodesCount () {
      return this.zipCodesList.length
    }
  },
  methods: {
    submitDistrictCodeForm (e) {
      if (this.supposedToBeDeleted) {
        return this.deleteDistrictCode(e)
      } else {
        return this.updateDistrictCode(e)
      }
    },
    updateDistrictCode (e) {
      DistrictCodesProvider.create({
        assignmentTermId: this.assignmentTermId,
        zipCodesList: this.editableZipCodesList,
        entireCountry: this.entireCountry,
        countryCode: this.countryCode
      }).then(resp => {
        this.loading = false
        this.showSuccessUpdateMessage = true
        setTimeout(() => {
          this.showSuccessUpdateMessage = false
        }, 2000)
      })
    },
    deleteDistrictCode (e) {
      DistrictCodesProvider.create({
        assignmentTermId: this.assignmentTermId,
        zipCodesList: [],
        countryCode: this.countryCode
      }).then(resp => {
        this.loading = false
        if (this.afterDestroy) {
          this.afterDestroy(this)
        }
        this.showSuccessUpdateMessage = true
        setTimeout(() => {
          this.showSuccessUpdateMessage = false
        }, 2000)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

fieldset {
  width: 100%;
}
</style>
